export default ['laura.diaz@foodforjoe.es'];
